import { createAllowedReturnUrlPatterns } from '@lx/quote-tool/lite/shared/utils';
import { COMPANIES, ENVIRONMENT_TYPES } from '@lx/shared/types';
import { QtLiteEnvironment } from '../app/types';

export const environment: QtLiteEnvironment = {
  API_BASE_PATH: 'https://api-dev.klgintdc.com/api',
  I18N_PATH: 'https://translations-dev.klgintdc.com',
  COMPANY: COMPANIES.KAPLAN, // Via URL parameters?
  LOCALE: 'en-US', // Default value, overridden via URL parameter 'locale'
  RTL_ENABLED: false, // Default value, resolved from LOCALE at runtime
  RTL_LOCALES: ['ar-SA'], // Locales that should be treated as RTL, can be extended as needed
  ONLINE_QT_BASE_URL: 'https://online-quote-tool-dev.klgintdc.com',
  production: false,
  environment: ENVIRONMENT_TYPES.development,

  /**
   * List of allowed domain patterns for return URLs.
   * Development allows both HTTP and HTTPS for local testing.
   */
  ALLOWED_RETURN_URL_DOMAIN_PATTERNS: createAllowedReturnUrlPatterns(),
  SUPPORTED_COMPANIES: [COMPANIES.KAPLAN, COMPANIES.ALPADIA, COMPANIES.POSITIVELY_LANGUAGES],
};
